import { Serializable } from 'ts-serializable';

export class ModelFactory {
  create<T extends Serializable>(Model: new () => T, data: object): T {
    return new Model().fromJSON({ ...data });
  }

  createList<T extends Serializable>(Model: new () => T, array: object[]): T[] {
    return array.map((item: object) => new Model().fromJSON({ ...item }));
  }
}

export const modelFactory = new ModelFactory();
